import PropTypes from "prop-types";
import React, { useRef, useEffect } from "react";
import BreadcrumbPill from "web/react/components/breadcrumb-pill/breadcrumb-pill";
import { AllSuggestedFilterInfo, FilterClickHandler } from "web/types/feed-filters";
import { UniversalFilterOption } from "web/types/universal-filters";
import { getSuggestedOptions } from "web/react/components/feeds-filters/hooks/use-filter-manager";
import styles from "./feeds-suggested-filters-pills.css";

interface SuggestionPillProps {
    suggestedFilterInfo: AllSuggestedFilterInfo;
    onClick: FilterClickHandler;
}

function SuggestionPills({
    suggestedFilterInfo,
    onClick,
}: SuggestionPillProps): null | JSX.Element {
    let suggestedOptions: UniversalFilterOption[] = getSuggestedOptions(suggestedFilterInfo);
    const showSuggestedOptions = suggestedOptions && suggestedOptions.length > 0;
    let scrollableWrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (scrollableWrapperRef && scrollableWrapperRef.current) {
            scrollableWrapperRef.current.scrollLeft = 0;
        }
    });

    return (
        <>
            {showSuggestedOptions ? (
                <div className={styles.scrollableWrapper} ref={scrollableWrapperRef}>
                    <ul className={styles.pills}>
                        {suggestedOptions.map((option) => (
                            <li className={styles.pill} key={`${option.name}=${option.value}`}>
                                <BreadcrumbPill
                                    onClick={(): void =>
                                        onClick(
                                            { ...option, event_prefix: "filter_suggested" },
                                            true,
                                            true
                                        )
                                    }
                                    title={option.label}
                                    href={option.url}
                                    iconName="plus-thin"
                                    iconPosition="before"
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </>
    );
}

export default SuggestionPills;

SuggestionPills.propTypes = {
    suggestedFilterInfo: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};
